import { IconButton, Typography, useTheme } from "@mui/material";
import { Moon, Sun } from "assets/Icon";

import React from "react";
import { THEMES } from "context/ThemeSwitcherContextProvider";
import useChangeTheme from "hooks/useChangeTheme";
import { useCookies } from "react-cookie";
import useIsMobileView from "hooks/useIsMobileView";

function ChangeThemeButton() {
  // eslint-disable-next-line no-unused-vars
  const [_, setCookie] = useCookies(["sana-theme"]);
  const isMobileView = useIsMobileView();

  const changeTheme = useChangeTheme();
  const theme = useTheme();

  const cookieOptions = {
    path: "/",
    maxAge: 31556952,
  };

  const handleChangeTheme = () => {
    const isChecked = changeTheme.theme === THEMES.secondary;

    if (isChecked) {
      changeTheme?.setTheme(THEMES.primary);
      setCookie("sana-theme", THEMES.primary, cookieOptions);
    } else {
      changeTheme?.setTheme(THEMES.secondary);
      setCookie("sana-theme", THEMES.secondary, cookieOptions);
    }
  };

  return (
    <IconButton
      size="small"
      sx={{ ml: 1 }}
      color="text"
      onClick={handleChangeTheme}
    >
      {isMobileView && (
        <Typography pr={1.5}>
          حالت {changeTheme.theme === THEMES.primary ? "روشن" : "تیره"}
        </Typography>
      )}

      {changeTheme?.theme === THEMES.primary ? (
        <Sun color={theme.palette.text.main} />
      ) : (
        <Moon color={theme.palette.text.main} />
      )}
    </IconButton>
  );
}

export default ChangeThemeButton;
